export default "__VITE_ASSET__b813b1ce__"